import { useCallback, useEffect, useState } from 'react';
import { Article, articlesService } from '../../../apiServices/articles.service';


export const useAllArticles = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchArticles = useCallback(async () => {
    setLoading(true);

    try {
      const data = await articlesService.getAll();
      setArticles(data);
    } catch (err) {
      setError("Error loading articles");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchArticles();
  }, [fetchArticles]);

  return {
    articles,
    loading,
    error,
    refetch: fetchArticles,
  };
};
